import { render, staticRenderFns } from "./AccidentDetail.vue?vue&type=template&id=74d22ac8&scoped=true"
import script from "./AccidentDetail.vue?vue&type=script&lang=js"
export * from "./AccidentDetail.vue?vue&type=script&lang=js"
import style0 from "./AccidentDetail.vue?vue&type=style&index=0&id=74d22ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d22ac8",
  null
  
)

export default component.exports